import * as React from 'react'
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { AppState } from '../../../store';

interface IProps {
	name: string
	rounded?: boolean
	width?: number
	src?: string
	onClick?: () => void
}

const Container = styled.div`
	position: relative;
	overflow: visible;
	display: flex;
	justify-content: center;
	align-items: center;
	transition: border-color .3s;
	border-radius: 7px;
	overflow: hidden;
	object-fit: cover;
	background: ${props => props.theme.color.background};
	color: ${({ theme }) => theme.color.backgroundText};

	${(props: IProps) => css`
		width: ${props.width}px;
		height: ${props.width}px;
		min-width: ${props.width}px;
		min-height: ${props.width}px;
		font-size: ${props.width / 2}px;
	`}

	${(props: IProps) => props.rounded && css`
		border-radius: 50%;
	`}

	${(props: IProps) => props.onClick && css`
		cursor: pointer;
	`}

	svg {
		width: 100%;
		height: auto;
		font-weight: bold;
	}

	img {
		width: 100%;
		height: auto;
		object-fit: cover;
	}
`

const Avatar = (props: IProps) => {
	const {
		rounded,
		width,
		onClick,
		name,
		src
	} = props

	return (
		<Container
			name={name}
			rounded={rounded}
			width={width}
			onClick={onClick}
		>
			{src && <img src={src} alt={name} />}
			{!src && name?.charAt(0).toUpperCase()}
		</Container>
	)
}

export default Avatar